import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import type { CreateElement } from 'vue';
import { VNode } from 'vue';
import moment from 'moment';
import NewSelectSite from '../newSelectSIte';
import style from './style.vue';
import { noop, numberToArray } from '@/util';
import { IPSService } from '@/services/ipsServices';
import AddAd from '@/views/components/shopAdvertisement/addAd.vue';

// 所需接口的列表，和service字段对应
const serviceList = {
  propageate: IPSService.gsPropageateList,
  case: IPSService.gsCaseList,
  video: IPSService.gsVideoList,
};

export enum AD_TYPE {
  QIKAN = 1,
  GOOGS,
  GOODSLIST,
  LIVE,
  SKILL,
  GROUP,
  ACTIVE,
  PROMI,
  GOODSSITE,
  NEWPROMO,
  PAGE,
  COUPON,
  APP,
  KILLGROUP = 19,
  PUSHMESSAGE,
}

export const AD_TEXT = {
  [AD_TYPE.QIKAN]: '期刊',
  [AD_TYPE.GOOGS]: '商品',
  [AD_TYPE.GOODSLIST]: '商品分类',
  [AD_TYPE.LIVE]: '直播',
  [AD_TYPE.SKILL]: '秒杀',
  [AD_TYPE.GROUP]: '团购',
  [AD_TYPE.ACTIVE]: '活动 ',
  [AD_TYPE.PROMI]: '促销',
  [AD_TYPE.GOODSSITE]: '商品组',
  [AD_TYPE.NEWPROMO]: '新促销',
  [AD_TYPE.PAGE]: '微页面',
  [AD_TYPE.COUPON]: '优惠卷',
  [AD_TYPE.APP]: '小程序',
  [AD_TYPE.KILLGROUP]: '秒杀组',
  [AD_TYPE.PUSHMESSAGE]: '公众号推文',
};

export enum AD_STATE {
  ALL,
  RELEASED, // 待发布
  PUBLISHED, // 已发布
  EXPIRED, // 已过期
  WITHDRAWN, // 已下架
}

export const AdStateText = {
  [AD_STATE.ALL]: '全部',
  [AD_STATE.PUBLISHED]: '进行中',
  [AD_STATE.RELEASED]: '未开始',
  [AD_STATE.EXPIRED]: '已过期',
  [AD_STATE.WITHDRAWN]: '已下架',
};

export const linkTypeSelect = ['全部', '期刊', '商品', '商品分类', '直播', '秒杀', '团购', '活动', '促销', '商品组', '新促销', '微页面', '优惠券', '小程序', '秒杀组', '公众号推文'];

@Component({
  mixins: [style],
  components: { AddAd },
})
export default class ShopDisplayTable extends Vue {
  @Prop({ default: {} })
    postParams: ItemObject;

  @Prop({ default: {} })
    selectNode;

  tableData = [];

  videoState = 9;

  advState = 0;

  page = 1;

  pageSize = 10;

  totalCount = 0;

  keyword = '';

  tableSelect = '';

  addAdDialog = false;

  addCaseDialog = false;

  addVideoDialog = false;

  addMiniPage = false;

  adTableSelectId = null;

  linkSelect = '';

  /**
   * 1 编辑 2 查看 3 优惠券专用状态此状态下不可改变优惠券但是可以编辑图片的和兑换价格
   */
  adState = 1;

  empCode = null;

  openCoupon = 0;

  // date = [];

  // protected defaultStart: Date;

  // protected defaultEnd: Date;

  async mounted() {
    this.empCode = this.$store.state.empCode;
  }

  @Watch('postParams', { deep: true })
  async watchPostParams() {
    this.page = this.postParams.page;
    this.pageSize = this.postParams.pageSize;
    this.keyword = this.postParams.keyword;
    if (this.postParams.parentId) {
      this.openCoupon = await this.getCouponConfig();
      this.getTableData();
    } else {
      this.tableData = [];
      this.totalCount = 0;
      this.page = 1;
      this.pageSize = 10;
      this.keyword = '';
      this.tableSelect = '';
      this.linkSelect = '';
      this.$emit('loadingClose');
    }
  }

  @Watch('addAdDialog')
  onaddAdDialogChange(n, o) {
    if (n !== o && n === false) {
      this.getTableData();
    }
  }

  getCouponConfig() {
    return IPSService.siteGroupConfig({
      postParams: {
        sgId: this.postParams.sgId || this.postParams.id,
      },
    }).then((res) => {
      return res.isOpenExchangeCoupon || 0;
    });
  }

  getTableData() {
    const postParams = {
      sgId: this.postParams.sgId || this.postParams.id,
      advState: Number(this.tableSelect),
      page: this.page,
      pageSize: this.pageSize,
      keyword: this.keyword,
      sgwpId: this.selectNode.sgwpId,
      linkType: this.linkSelect,
      openType: this.selectNode.fieldType === 'OpenAd' ? this.selectNode.showType : '',
      pageId: this.selectNode.pageId || 0,
    };
    // if (this.date && this.date.length) {
    //   (postParams["startOfTime"] = Date.parse(new Date(new Date(new Date(this.date[0]).toLocaleDateString()).getTime())) / 1000 || ""),
    //     (postParams["endOfTime"] = Date.parse(new Date(new Date(new Date(this.date[1]).toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)) / 1000 || "");
    //   if (this.date[1] - this.date[0] > 180 * 24 * 3600 * 1000) {
    //     this.$message.error("提现申请时间跨度不能超过6个月！");
    //     this.date = [this.defaultStart, this.defaultEnd];
    //     return;
    //   }
    // }
    IPSService.gsPropageateList({
      postParams,
    })
      .then((response) => {
        this.tableData = response.list;
        this.totalCount = response.count;
        this.$emit('loadingClose');
      })
      .catch((error) => {
        this.$emit('loadingClose');
      });
  }

  /**
   * 搜索
   */
  handleSearch() {
    if (this.postParams.parentId) {
      this.getTableData();
    }
  }

  /**
   * 筛选条件改变
   * @param val
   */
  handleTableSelectChange(val) {
    this.page = 1;
    this.getTableData();
  }

  /**
   * 操作栏按钮
   * @param h
   * @param row
   */
  renderTableBtn(h, row) {
    const { advState, advId, operAuthority } = row;
    if (!operAuthority || advState === AD_STATE.EXPIRED) {
      return (
        <p>
          <span class="scopeSpan" onClick={this.handleCheck.bind(this, advId)}>
            查看
          </span>
        </p>
      );
    }
    return (
      <p>
        {(advState === AD_STATE.RELEASED || advState === AD_STATE.PUBLISHED || advState === AD_STATE.WITHDRAWN) && (
          <span class="scopeSpan" onClick={this.handleEditAd.bind(this, advId)}>
            编辑
          </span>
        )}
        {(advState === AD_STATE.RELEASED || advState === AD_STATE.PUBLISHED) && (
          <span class="scopeSpan" onClick={this.handleChangeState.bind(this, advId, 0)}>
            下架
          </span>
        )}
        {advState === AD_STATE.WITHDRAWN && (
          <span class="scopeSpan" onClick={this.handleChangeState.bind(this, advId, 1)}>
            上架
          </span>
        )}
        <span class="scopeSpan" onClick={this.handleChangeState.bind(this, advId, -1)}>
          删除
        </span>
      </p>
    );
  }

  /**
   * 添加广告
   */
  handleAddAd() {
    this.adState = 1;
    this.adTableSelectId = null;
    this.addAdDialog = true;
  }

  /**
   * 列表每页显示数量改变
   * @param val
   */
  onSizeChange(val) {
    this.page = 1;
    this.pageSize = val;
    this.getTableData();
  }

  /**
   * 切换页码
   * @param val
   */
  onPageChange(val) {
    this.page = val;
    this.getTableData();
  }

  renderDialog(h) {
    return (
      this.addAdDialog && [
        <AddAd
          v-model={this.addAdDialog}
          treeSelect={this.postParams}
          openType={this.selectNode.fieldType === 'OpenAd' ? this.selectNode.showType : ''}
          isOpenAd={this.selectNode.openType || 0}
          tableSelectId={this.adTableSelectId}
          state={this.adState}
          pageId={this.selectNode.pageId || 0}
          openCoupon={this.openCoupon}
        />,
      ]
    );
  }

  handleCheck(id) {
    this.adState = 2;
    this.adTableSelectId = id;
    this.addAdDialog = true;
  }

  handleEditAd(id) {
    this.adState = 1;
    this.adTableSelectId = id;
    this.addAdDialog = true;
  }

  handleChangeState(advId, state) {
    this.$confirm(`是否${state === -1 ? '删除' : state === 1 ? '上架' : '下架'}该广告？`, '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      closeOnClickModal: false,
      type: 'warning',
    }).then((resj) => {
      if (resj === 'confirm') {
        IPSService.gsPropageateStateUpdate({
          postParams: {
            advId,
            state,
          },
        }).then(
          (res) => {
            if (res.result) {
              this.$message.success(`${state === -1 ? '删除' : state === 1 ? '上架' : '下架'}成功`);
              if (state === -1) {
                this.page = 1;
              }
              this.getTableData();
            } else {
              this.$message.error(`${state === -1 ? '删除' : state === 1 ? '上架' : '下架'}失败`);
            }
          },
          () => {
            this.$message.error(`${state === -1 ? '删除' : state === 1 ? '上架' : '下架'}失败`);
          },
        );
      }
    }, noop);
  }

  renderFilter(h: CreateElement) {
    return (
      <div class="filterController">
        <div class="inputWrapper wid-100">
          <el-input v-model={this.keyword} placeholder="广告标题" onEnter={this.handleSearch.bind(this)} disabled={!this.postParams.parentId} />
          <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)} />
        </div>
        <el-select v-model={this.linkSelect} disabled={!this.postParams.parentId} onChange={val => this.handleTableSelectChange(val)} placeholder="广告类别">
          {linkTypeSelect.map((v, i) => {
            if (v === '秒杀组') {
              return <el-option label={v} value={19} key={19}></el-option>;
            } else if (v === '公众号推文') {
              return <el-option label={v} value={20} key={20}></el-option>;
            } else {
              return <el-option label={v} value={i} key={i}></el-option>;
            }
          })}
        </el-select>
        <el-select v-model={this.tableSelect} disabled={!this.postParams.parentId} onChange={val => this.handleTableSelectChange(val)} placeholder="状态">
          {Object.keys(AdStateText).map((v, i) => {
            return <el-option key={`${v}${i}`} value={v} label={AdStateText[v]} />;
          })}
        </el-select>
        {/* <div class="inputWrapper wid-300">
          <span class="font-size-14 r-ml-20 r-mr-10">更新时间</span>
          <el-date-picker v-model={this.date} type="daterange" format="yyyy 年 MM 月 dd 日" onChange={this.getTableData} range-separator="~" />
        </div> */}
      </div>
    );
  }

  renderBottomButton(h: CreateElement) {
    return (
      <div class="bottomWrapper">
        <el-button type="primary" onClick={this.handleAddAd.bind(this)} disabled={!this.postParams.parentId}>
          追加广告
        </el-button>
        {this.postParams.parentId && (
          <el-pagination
            disabled={!this.postParams.parentId}
            on-size-change={e => this.onSizeChange(e)}
            on-current-change={e => this.onPageChange(e)}
            currentPage={this.page}
            pageSizes={[10, 15, 20, 30]}
            pageSize={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.totalCount}
          />
        )}
      </div>
    );
  }

  renderAd(h: CreateElement) {
    return (
      <el-table class="el-table" element-loading-text="加载中" width="100%" height="calc(100% - 107px)" data={this.tableData} tooltip-effect="light">
        <el-table-column type="index" label="ID" align="center" />
        <el-table-column prop="advName" label="广告标题" show-overflow-tooltip />
        <el-table-column
          prop="siteCodeList"
          label="适用网点"
          align="center"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                return (
                  <span
                    class="scopeSpan"
                    onClick={() => {
                      new NewSelectSite().open({
                        sgId: this.postParams.parentId,
                        selectCodes: scope.row.siteCodeList.map((i) => {
                          return typeof i !== 'string' ? i.siteCode : i;
                        }),
                        readonly: true,
                      }).then(noop, noop);
                    }}>
                    {scope.row.siteCodeList.length}
                  </span>
                );
              },
            },
          }}
        />
        <el-table-column
          prop="advBeginTime"
          label="广告有效期"
          align="left"
          width="200"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                if (scope.row.advBeginTime == 0 && scope.row.advEndTime == 0) {
                  return '长期有效';
                }
                return [<p class="table-scope-p">{`${moment(scope.row.advBeginTime * 1000).format('YYYY-MM-DD HH:mm')}~`}</p>, <p class="table-scope-p">{moment(scope.row.advEndTime * 1000).format('YYYY-MM-DD HH:mm')}</p>];
                // return (
                //   moment(scope.row.advBeginTime * 1000).format("YYYY-MM-DD HH:mm") +
                //   "~" +
                //   moment(scope.row.advEndTime * 1000).format("YYYY-MM-DD HH:mm")
                // );
              },
            },
          }}
        />
        <el-table-column
          prop="linkTypes"
          label="广告类别"
          align="center"
          width="80"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                const list = Array.isArray(scope.row.linkTypes) ? scope.row.linkTypes.filter(Boolean) : [];
                return list.length
                  ? list
                    .map((i) => {
                      return AD_TEXT[i];
                    })
                    .join(',')
                  : '无';
              },
            },
          }}
        />
        <el-table-column
          prop="advState"
          label="状态"
          align="center"
          width="80"
          {...{
            scopedSlots: {
              default: (scope) => {
                return AdStateText[scope.row.advState];
              },
            },
          }}
        />
        <el-table-column prop="updatePerson" label="更新人" align="center" />
        <el-table-column
          prop="updateTime"
          label="更新时间"
          width="180"
          show-overflow-tooltip
          {...{
            scopedSlots: {
              default: (scope) => {
                return moment(scope.row.updateTime * 1000).format('YYYY-MM-DD HH:mm');
              },
            },
          }}
        />
        <el-table-column
          align="center"
          label="操作"
          width="150"
          fixed="right"
          {...{
            scopedSlots: {
              default: (scope) => {
                return this.renderTableBtn(h, scope.row);
              },
            },
          }}
        />
      </el-table>
    );
  }

  render(h: CreateElement) {
    return (
      <div class="shopTableWrapper height-100">
        {this.renderFilter(h)}
        {this.renderAd(h)}
        {this.renderBottomButton(h)}
        {this.renderDialog(h)}
      </div>
    );
  }
}
